module.exports = __webpack_public_path__ + "img/menu-Setting.d7a3d7b2.svg";